/**
 * @file: AiCreditBalanceLabel.tsx
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo } from 'react';
import { formatAiCredits } from '../functions/formatAiCredits';

export const AiCreditBalanceLabel = memo(function AiCreditBalanceLabel({
  balance,
  color,
}: {
  balance: number;
  color: string;
}) {
  const { rpx } = useResponsiveContext();
  return (
    <Typography.Text size={rpx(12)} color={color} numberOfLines={1}>
      AI 积分 {formatAiCredits(balance)}
    </Typography.Text>
  );
});
